import React from 'react';
import classNames from 'classnames';
import { NavLink } from 'react-router';

import { RCStarRating } from '@reverbdotcom/cadence/components';

export interface IProps {
  text: string;
  url?: string;
  count?: number | string;
  /** Styles the link as active, overriding the router's 'active' determination */
  activeOverride?: boolean;
  onClick?: (evt: any) => void;
  /** Renders a star rating in the tab (0.0-1.0) */
  starRating?: number;
  /** Only mark this tab active on an exact path match (react-router IndexLink behavior) */
  indexLink?: boolean;
  transparentBorder?: boolean;
}

/** Only to be used as a child of SharedTabs */
export class SharedTab extends React.Component<IProps, null> {
  getActiveClassName() {
    if (this.props.url === '#' || this.props.hasOwnProperty('activeOverride')) return;

    return 'shared-tabs__tab--active';
  }

  render() {
    // optionally hardcodes active class
    const classes = classNames(
      'shared-tabs__tab',
      { 'shared-tabs__tab--active': this.props.activeOverride },
      { 'shared-tabs__tab--transparent-border': this.props.transparentBorder },
    );

    return (
      <NavLink
        className={({ isActive }) => classNames(classes, isActive && this.getActiveClassName())}
        end={this.props.indexLink}
        to={this.props.url}
        onClick={this.props.onClick}
      >
        <div className="shared-tabs__text">
          {this.props.text}
        </div>
        {this.props.count !== undefined &&
          <div className="shared-tabs__count">
            {this.props.count}
          </div>
        }
        {this.props.starRating !== undefined &&
          <div className="shared-tabs__rating">
            <RCStarRating
              rating={this.props.starRating}
              hideTooltip
            />
          </div>
        }
      </NavLink>
    );
  }
}

export default SharedTab;
